export default __webpack_public_path__ + "static/media/ds.3ab88f64.png";